import { render } from "./ForumAdmin.vue?vue&type=template&id=3a5b536e&scoped=true"
import script from "./ForumAdmin.vue?vue&type=script&lang=js"
export * from "./ForumAdmin.vue?vue&type=script&lang=js"

import "./ForumAdmin.vue?vue&type=style&index=0&id=3a5b536e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5b536e"]])

export default __exports__